/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Network_List_TitleInputs */

const fr_map_network_list_title = /** @type {(inputs: Map_Network_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des réseaux`)
};

const en_map_network_list_title = /** @type {(inputs: Map_Network_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network list`)
};

/**
* | output |
* | --- |
* | "Network list" |
*
* @param {Map_Network_List_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_network_list_title = /** @type {((inputs?: Map_Network_List_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Network_List_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_network_list_title(inputs)
	return en_map_network_list_title(inputs)
});